import React from "react";
import { Wrapper, Scroll } from "app/NativeComponents/common";

import ProfileOptions from "./ProfileOptions";
import MailingOptions from "./MailingOptions";
import NotificationOptions from "./NotificationOptions";

import AppOptions from "./AppOptions";
import PromoOptions from "./PromoOptions";
import ExportOptions from "./ExportOptions";
import BillingOptions from "./BillingOptions";
import ZapierOptions from "./ZapierOptions";

const Body = props => {
  if (props.user) {
    return (
      <Scroll>
        <ProfileOptions {...props} />
        <MailingOptions {...props} />
        <NotificationOptions {...props} />
        <PromoOptions {...props} />
        <AppOptions {...props} />
        <ExportOptions {...props} />
        <BillingOptions {...props} />
        <ZapierOptions />
      </Scroll>
    );
  }

  return <Wrapper />;
};

export default Body;
